import React, { Component } from 'react';
import {
  EmptyStateContainer,
  FiltersContainer,
  SearchContainer
} from '../../../../index';
import { connect } from 'react-redux';
import Autoload from '../../../../Autoload';

import { showNotification, hideNotification } from '@mantine/notifications';
import RedTick from '../../../../../assets/images/module/general/RedTick.svg';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import AddIcon from '../../../../../assets/images/module/general/AddIcon.svg';
import InfoIcon from '../../../../../assets/images/module/general/InfoIcon.svg';
import MessagesIcon from '../../../../../assets/images/module/general/MessagesIcon.svg';
import DeleteIcon from '@material-ui/icons/Delete';

import { Alert, Group, Popover, Stack, Text, Tooltip } from "@mantine/core";
import * as customParseFormat from 'dayjs/plugin/customParseFormat'
import dayjs from 'dayjs';
import TemplateServices from '../../../../helpers/services/TemplateServices';
import { hover } from 'glamor';
import MessageTemplateDeletionConfirmationModal from '../CustomModal/MessageTemplateDeletionConfirmationModal';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
var { checkProperty, yearDifference, yearDifferenceMoment } = Autoload.MainHelper;
dayjs.extend(customParseFormat)

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;

class MessageTemplates extends Component {
  state = {
    data: [],
    selectedCategory: 'General',
    hoveredTemplateId: null,
    search: null,
    openDeleteTemplateModal: false,
    selectedTemplateId: null,
    deletionInProgress: false
  };
  
  constructor(props) {
    super(props);
  }

  componentDidMount(){
    const {messageTemplates} = this.props;
    console.log('messageTemplates: ', messageTemplates);
    
    // if(messageTemplates?.length > 0){
    //     this.setState({data: messageTemplates});
    // }
    TemplateServices.getTemplates(this, 'handleGetTemplates', null, this.props);
    TemplateServices.getSystemTemplates(this, 'handleGetSystemTemplates', null, this.props);
  }

  handleGetSystemTemplates(response){
    if(response.status && response.statuscode === 200){
        
    }else if(response.status === false && response.message === 'Not Found'){
        
    }
  }

  handleGetTemplates(response){
    if(response.status && response.statuscode === 200){
        if(response?.result?.length > 0){
            this.setState({data: response.result});
        }
    }else if(response.status === false && response.message === 'Not Found'){
        this.setState({data: []});
    }
  }

  getTemplateTypeText(type){
    switch(type){
        case 'RentalPayment':
            return 'Mahnung wegen Zahlungsverzug Miete';
        case 'Tenant':
            return 'Mieter';
        case 'General':
            return 'Extern';
        case 'BillingStatement':
            return 'Betriebskostenabrechnung';
        default:
            return '';
    }
  }

  openNewMessage(templateSubject=null, templateBody=null, templateId=null){
    const { open, toggle, className, selectedMessageType, selectedTenantId} = this.props;
    if(typeof this.props?.toggle === 'function'){
        this.props.toggle();
    }
    if(selectedTenantId){
      this.props.history.push('/messaging/newMessage', {
        tenantId: selectedTenantId,
        messageType: 'General',
        createNewTenantMessage: true,
        previousUrl: selectedTenantId ? `/user/tenant/information?tenantId=${selectedTenantId}` : null,
        templateSubject, templateBody, templateId
      });
    }else{
      this.props.history.push('/messaging/newMessage', {messageType: selectedMessageType || 'General', templateSubject, templateBody, templateId});
    }
  }

  handleDeleteTemplate(response){
    if(response.status && response.statuscode === 200){
        showNotification({
            message: 'Die Vorlage wurde erfolgreich gelöscht.',
            icon: <img src={RedTick} />,
          });
          TemplateServices.getTemplates(this, 'handleGetTemplates', null, this.props);
    }
    else{
        showNotification({
            message: 'Beim Löschen der Vorlage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
            icon: <img src={RedTick} />,
          });
    }
    this.setState({openDeleteTemplateModal: false, selectedTemplateId: null, deletionInProgress: false});
  }

  handleDelete=(e, id)=>{
    e.stopPropagation();
    this.setState({openDeleteTemplateModal: true, selectedTemplateId: id});
  }

  handleTemplateTypeChange(type){
    this.setState({selectedCategory: type});
  }

  handleSearchHandler=(e)=>{
    this.setState({search: e.target.value});
  }
  
  render() {
    const { open, toggle, className, selectedMessageType} = this.props;
    const { data, selectedCategory, hoveredTemplateId, search, openDeleteTemplateModal, selectedTemplateId, deletionInProgress } = this.state;

    const isMessageTemplateScreen = window.location.href.includes('/messaging/templates');

    console.log('selectedMessageType: ', selectedMessageType);
    
    

    const filteredData = data.filter((item)=> item?.templateType === (isMessageTemplateScreen ? selectedCategory : selectedMessageType));
    return (
    <Group wrap="nowrap" style={{alignItems: 'flex-start', marginTop: isMessageTemplateScreen && '30px'}} gap={24}>
        <Stack justify={'flex-end'} style={{width: '100%'}}>
            <FiltersContainer
            style={{marginBottom: 0}}
            searchElement={
            <SearchContainer
            placeholder={'Vorlagen durchsuchen'}
            value={search}
            onChange={this.handleSearchHandler}
            disabled={filteredData?.length === 0}
            className={"annual-reading-search"}
            />
            }
            sortElement={null}
            />
            <Stack className='template-modal-main-container'>
              {filteredData?.length > 0 &&
              <Group gap={5}>
                <img src={InfoIcon}/>
                <Text className='templates-first-text' >Um eine neue Vorlage zu erstellen, erstellen Sie eine Nachricht und speichern Sie diese als Vorlage ab.</Text>
              </Group>}
              
                <Stack gap={0}>
                    <Stack style={{marginBottom: '30px', overflowY: 'scroll'}}>
                        {filteredData?.length > 0 ?
                        <Group>
                            <Tooltip label={'Neue Nachricht erstellen'} position='bottom' zIndex={99999}>
                                <Stack gap={0} className={`template-icon ${hoveredTemplateId === 'new' ? 'hovered' : ''} template-icon-container-new`}  onClick={()=> this.openNewMessage()} onMouseEnter={() => this.setState({ hoveredTemplateId: 'new' })} onMouseLeave={() => this.setState({ hoveredTemplateId: null })}>
                                  <Stack style={{padding: '10px'}} gap={0} justify='center'>
                                    <Group className='template-icon-text'>
                                        <span>Neue Nachricht</span>
                                    </Group>
                                  </Stack>
                                  <Stack style={{padding: '10px', height: '100%'}} gap={5} justify='center' align='center'>
                                      <Group className='blank-template-icon'>
                                          <img src={AddIcon}/>
                                      </Group>
                                  </Stack>
                                </Stack>
                            </Tooltip>
                            {filteredData.filter((item)=> !search || (item.subject.toLowerCase().includes(search.toLowerCase()) || item.body.toLowerCase().includes(search.toLowerCase())))
                            .sort((a, b)=> a.subject.toString().localeCompare(b.subject.toString()))
                            .map((item)=>
                            <Popover
  key={item.id}
  opened={hoveredTemplateId === item.id}
  // 1. Combine position and placement into a single string
  position="bottom-start" 
  trapFocus={false}
  zIndex={99999}
>
  {/* 2. Target Wrapper */}
  <Popover.Target>
    <Stack 
      gap={0} 
      className={`template-icon ${hoveredTemplateId === item.id ? 'hovered' : ''}`}  
      onClick={() => this.openNewMessage(item?.subject, item?.body, item?.id)} 
      onMouseEnter={() => this.setState({ hoveredTemplateId: item.id })} 
      onMouseMove={() => this.setState({ hoveredTemplateId: item.id })} 
      onMouseLeave={() => this.setState({ hoveredTemplateId: null })}
    >
      <Stack style={{ padding: '10px' }} gap={5} justify="center">
        <Stack gap={0} justify="center">
          <Group wrap="nowrap" className="template-icon-text">
            <div dangerouslySetInnerHTML={{ __html: item?.subject || '<p>(kein Betreff)<p>' }} />
            <Group onClick={(e) => this.handleDelete(e, item?.id)} style={{ cursor: 'pointer' }}>
              <Tooltip label="Vorlage löschen" position="top">
                <button type="button" className="close delete-cost-position" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </Tooltip>
            </Group>
          </Group>
        </Stack>
        <Group>
          <div className="template-icon-sub-text" dangerouslySetInnerHTML={{ __html: item?.body }} />
        </Group>
      </Stack>
    </Stack>
  </Popover.Target>

  {/* 3. Dropdown Wrapper */}
  <Popover.Dropdown>
    <Stack gap={0} justify="center">
      <Group wrap="nowrap" className="template-icon-full-text">
        <div dangerouslySetInnerHTML={{ __html: item?.subject || '<p>(kein Betreff)<p>' }} />
      </Group>
      <Group style={{ marginTop: '20px' }}>
        <div className="template-icon-sub-full-text" dangerouslySetInnerHTML={{ __html: item?.body }} />
      </Group>
    </Stack>
  </Popover.Dropdown>
</Popover>)}
                        </Group>
                        :
                        <EmptyStateContainer
                        heading={'Keine Vorlagen gefunden'}
                        subheading={'Es sind keine Vorlagen verfügbar. Bitte erstellen Sie eine neue Nachricht, um diese als Vorlage zu speichern.'}
                        showBtn={true}
                        btnText={'Neue Nachricht erstellen'}
                        btnHandler={()=> this.openNewMessage()}
                        icon={MessagesIcon}
                        />
                        }
                    </Stack>
                </Stack>
                
            </Stack>
        </Stack>
        {openDeleteTemplateModal &&
        <MessageTemplateDeletionConfirmationModal
        open={openDeleteTemplateModal}
        deletionInProgress={deletionInProgress}
        toggle={() => this.setState({ openDeleteTemplateModal: false, selectedTemplateId: null, deletionInProgress: false })}
        deleteTemplate={() => this.setState({ deletionInProgress: true }, () => TemplateServices.deleteTemplate(this, 'handleDeleteTemplate', null, selectedTemplateId))}
        />}
    </Group>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    propertySelected: state.generalReducer.property,
    messageTemplates: state.generalReducer.messageTemplates,
  };
};

export default connect(mapStateToProps)(MessageTemplates);